import { useEffect, useState } from "react";

/** Milliseconds left before `expiresAt`, never negative. An unreadable date counts as expired. */
export function remainingMs(expiresAt: string, now: number): number {
  const end = Date.parse(expiresAt);
  return Number.isNaN(end) ? 0 : Math.max(0, end - now);
}

/** "4:07" for 247 seconds, rounded up so it reaches 0:00 exactly at expiry. */
export function formatRemaining(ms: number): string {
  const total = Math.ceil(ms / 1000);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

/** Ticks every second until `expiresAt`. */
export function useRemaining(expiresAt: string): number {
  const [now, setNow] = useState(() => Date.now());
  const left = remainingMs(expiresAt, now);
  const expired = left === 0;
  useEffect(() => {
    if (expired) return;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [expired]);
  return left;
}
